






















import { computed, defineComponent } from "@vue/composition-api";
import { Notification } from "@scrile/api-provider/dist/api/NotificationsProvider";
import { ParticipantStatus } from "@scrile/api-provider/dist/api/ParticipantProvider";
import BaseButton from "@/components/BaseButton";
import NotificationItemView from "../../NotificationItemView.vue";

export default defineComponent({
  name: "NotificationParticipantCreated",
  components: { BaseButton, NotificationItemView },
  props: {
    notification: { type: Object as () => Notification, required: true },
  },
  setup(props) {
    const participant = computed(() => props.notification.details.participant);
    const showButton = computed(
      () => participant.value?.status === ParticipantStatus.NEW && !!participant.value.postOwnerId
    );

    return {
      showButton,
    };
  },
});
